module.exports = __webpack_public_path__ + "images/花筑村全景_04-1.jpg?v=80a675df";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_04-1.jpg
 ** module id = 89
 ** module chunks = 1 2
 **/